import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { CommonService } from 'src/app/shared/service/common.service';
import { CloudReadinessAssessmentService } from '../cloud-readiness-assessment.service';
import { ExportService } from 'src/app/modules/core/export.service';
import { EChartsOption } from 'echarts';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
/* eslint-disable */

@Component({
  selector: 'nio-cloud-readiness-report',
  templateUrl: './cloud-readiness-report.component.html',
  styleUrls: ['./cloud-readiness-report.component.scss'],
  standalone: false,
})
export class CloudReadinessReportComponent implements OnInit {
  answers: any;
  sectionKeys;
  reportId;
  assessmentSectionsAverageScore = {};
  chartOption: EChartsOption;
  loading = true;
  constructor(
    private commonService: CommonService,
    private cloudReadinessAssessmentService: CloudReadinessAssessmentService,
    private exportService: ExportService,
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.reportId = this.route.snapshot.params.report_id;
    console.log('Report ID:', this.reportId);
    if (this.reportId) {
      this.getPublicCloudReadinessReport(this.reportId);
    }
  }

  getPublicCloudReadinessReport(reportId) {
    this.loading = true;
    this.cloudReadinessAssessmentService
      .getPublicCloudReadinessReport(reportId)
      .subscribe(
        (cloudReadinessReportData: any) => {
          // this.loadingMarketplaceAgreementsDetails = false;
          // console.log('agreementsDetailsData: >> ', agreementsDetailsData);
          console.log(
            'Cloud Readiness Report Data: >> ',
            cloudReadinessReportData,
          );
          this.loading = false;
          this.answers = cloudReadinessReportData;
          this.sectionKeys = Object.keys(this.answers.answers);
          this.drawRadarChart();
          this.cdr.markForCheck();
        },
        (err) => {
          this.loading = false;
          // this.loadingMarketplaceAgreementsDetails = false;
          if (err?.error?.message) {
            this.commonService.errorMessage(err?.error?.message);
          } else {
            this.commonService.errorMessage(
              'Error While Getting Cloud Readiness Report Data.',
            );
          }
          this.cdr.markForCheck();
        },
      );
  }

  drawRadarChart(): void {
    this.getAnswersAverageValueForEachSection();
    this.chartOption = {
      tooltip: {},
      radar: {
        indicator: [
          { name: 'Business', max: 5 },
          { name: 'People', max: 5 },
          { name: 'Governance', max: 5 },
          { name: 'Platform', max: 5 },
          { name: 'Security', max: 5 },
          { name: 'Operation', max: 5 },
        ],
        radius: '70%',
        splitNumber: 5, // divide into 5 rings
        splitLine: {
          lineStyle: { color: '#ccc' },
        },
        splitArea: {
          areaStyle: { color: ['#f5f5f5', '#ebebeb'] },
        },
        axisLine: {
          lineStyle: { color: '#999' },
        },
        axisName: {
          color: '#333',
          fontSize: 13,
        },
      },
      series: [
        {
          type: 'radar',
          data: [
            {
              value: [
                this.assessmentSectionsAverageScore['business'],
                this.assessmentSectionsAverageScore['people'],
                this.assessmentSectionsAverageScore['governance'],
                this.assessmentSectionsAverageScore['platform'],
                this.assessmentSectionsAverageScore['security'],
                this.assessmentSectionsAverageScore['operation'],
              ],
              name: 'Cloud Readiness',
              areaStyle: { color: 'rgba(0,123,255,0.4)' },
              lineStyle: { color: '#007bff' },
              symbol: 'circle',
              symbolSize: 6,
              itemStyle: { color: '#007bff' },
              label: {
                show: true,
                formatter: (params: any) => params.value.toFixed(1),
                color: '#000',
                fontSize: 11,
              },
            },
          ],
        },
      ],
    };
  }

  getAnswersAverageValueForEachSection() {
    for (const section of this.sectionKeys) {
      const sectionData = this.answers.answers[section];
      const total = sectionData.reduce((sum, item) => sum + item.rating, 0);
      const average = total / sectionData.length;
      this.assessmentSectionsAverageScore[section] = parseFloat(
        average.toFixed(2),
      );
    }
    console.log(
      '@this.assessmentSectionsAverageScore >>> ',
      this.assessmentSectionsAverageScore,
    );
  }
  // getSectionKeys(): string[] {
  //   return Object.keys(this.answers.answers);
  // }

  // Dynamic color selection
  getColorClass(rating: number): string {
    return rating >= 4 ? 'green-bg' : 'orange-bg';
  }

  getRecommendedActions(section) {
    const recommendations = [];
    this.answers.answers[section].forEach((item) => {
      recommendations.push({
        title: item.title,
        recommendations: item.recommendations,
      });
    });
    return recommendations;
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  async exportFullPageToPDF1(): Promise<void> {
    try {
      // Show loading message
      this.commonService.successMessage('Generating PDF... Please wait.');

      const html2canvas = (await import('html2canvas')).default;
      const { jsPDF } = await import('jspdf');

      // Get the report container element
      const element = document.querySelector(
        '.report-container-content',
      ) as HTMLElement;

      if (!element) {
        this.commonService.errorMessage(
          'Report container not found. Please try again.',
        );
        return;
      }

      // Temporarily hide scrollbars and optimize element for rendering
      const originalOverflow = element.style.overflow;
      element.style.overflow = 'visible';

      // Configure html2canvas for faster rendering with good quality
      const canvas = await html2canvas(element, {
        scale: 1.5, // Reduced scale for faster rendering
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
        width: element.scrollWidth,
        height: element.scrollHeight,
        scrollX: 0,
        scrollY: 0,
        windowWidth: element.scrollWidth,
        windowHeight: element.scrollHeight,
        foreignObjectRendering: false, // Disable for better performance
        removeContainer: true, // Clean up after rendering
        imageTimeout: 0, // Disable image timeout for faster rendering
      });

      // Use lower quality for faster processing
      const imgData = canvas.toDataURL('image/jpeg', 0.8);
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;

      // Create PDF with A4 format
      const pdf = new jsPDF({
        orientation: imgWidth > imgHeight ? 'landscape' : 'portrait',
        unit: 'mm',
        format: 'a4',
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 10; // 10mm margin
      const contentWidth = pageWidth - 2 * margin;
      const contentHeight = pageHeight - 2 * margin;

      // Calculate scaling to fit the image
      const scale = Math.min(
        contentWidth / imgWidth,
        contentHeight / imgHeight,
      );
      const scaledWidth = imgWidth * scale;
      const scaledHeight = imgHeight * scale;

      // Center the image on the page
      const xOffset = (pageWidth - scaledWidth) / 2;
      const yOffset = (pageHeight - scaledHeight) / 2;

      // If the content fits on one page, add it directly
      if (scaledHeight <= contentHeight) {
        pdf.addImage(
          imgData,
          'JPEG',
          xOffset,
          yOffset,
          scaledWidth,
          scaledHeight,
        );
      } else {
        // If content is too tall, split it across multiple pages
        const pageCount = Math.ceil(scaledHeight / contentHeight);

        for (let i = 0; i < pageCount; i++) {
          if (i > 0) {
            pdf.addPage();
          }

          // Calculate the portion of the image to show on this page
          const sourceY = (i * contentHeight) / scale;
          const sourceHeight = Math.min(
            contentHeight / scale,
            imgHeight - sourceY,
          );

          // Create a temporary canvas for this page slice
          const pageCanvas = document.createElement('canvas');
          pageCanvas.width = imgWidth;
          pageCanvas.height = sourceHeight;

          const ctx = pageCanvas.getContext('2d');
          if (ctx) {
            // Draw the specific portion of the original canvas
            ctx.drawImage(
              canvas,
              0,
              sourceY,
              imgWidth,
              sourceHeight, // source
              0,
              0,
              imgWidth,
              sourceHeight, // destination
            );

            // Use JPEG for faster processing
            const pageImgData = pageCanvas.toDataURL('image/jpeg', 0.8);

            // Add image to PDF
            pdf.addImage(
              pageImgData,
              'JPEG',
              margin,
              margin,
              contentWidth,
              sourceHeight * scale,
            );
          }
        }
      }

      // Restore original overflow style
      element.style.overflow = originalOverflow;

      // Save the PDF
      pdf.save('cloud-readiness-assessment-report.pdf');

      // Show success message
      this.commonService.successMessage('PDF generated successfully!');
    } catch (error) {
      console.error('Error generating PDF:', error);
      this.commonService.errorMessage(
        'Failed to generate PDF. Please try again.',
      );
    }
  }

  async exportFullPageToPDF(): Promise<void> {
    try {
      // Show loading message
      this.commonService.successMessage('Generating PDF file... Please wait.');

      // Add timeout to prevent hanging
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => reject(new Error('PDF generation timeout')), 60000); // 60 second timeout for multiple files
      });

      const exportPromise = this.performMultiplePDFExport();

      await Promise.race([exportPromise, timeoutPromise]);
    } catch (error) {
      console.error('Error generating PDF:', error);
      if (error.message === 'PDF generation timeout') {
        this.commonService.errorMessage(
          'PDF generation timed out. Please try again.',
        );
      } else {
        this.commonService.errorMessage(
          'Failed to generate PDF. Please try again.',
        );
      }
    }
  }

  private async performMultiplePDFExport(): Promise<void> {
    // Use dynamic imports for faster loading
    const [html2canvasModule, jsPDFModule] = await Promise.all([
      import('html2canvas'),
      import('jspdf'),
    ]);

    const html2canvas = html2canvasModule.default;
    const { jsPDF } = jsPDFModule;

    // Create a single PDF document
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
      compress: true,
      precision: 2,
    });

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 20;
    const contentWidth = pageWidth - 2 * margin;
    let currentY = margin;
    // Reduced default line height to tighten vertical spacing.
    // Keep a small minimum so very small fonts don't overlap.
    // Use a tighter line height based on fontSize.
    // previous formula produced very large gaps for common font sizes (e.g. 10 => 12).
    // New formula keeps spacing compact but readable: at least 5px, otherwise ~0.8 * fontSize.
    const lineHeight = Math.max(5, Math.round(12 * 0.8));
    const sectionSpacing = 10;

    // Helper function to add text with automatic page breaks
    const addText = (
      text: string,
      fontSize: number = 12,
      isBold: boolean = false,
      color: string = '#000000',
    ) => {
      pdf.setFontSize(fontSize);
      pdf.setFont('helvetica', isBold ? 'bold' : 'normal');
      pdf.setTextColor(color);

      const textLines = pdf.splitTextToSize(text, contentWidth);

      for (const line of textLines) {
        // Check if we need a new page
        if (currentY + lineHeight > pageHeight - margin) {
          pdf.addPage();
          currentY = margin;
        }

        pdf.text(line, margin, currentY);
        currentY += lineHeight;
      }
    };

    // Add main title
    addText('Cloud Readiness Assessment Report', 20, true, '#1976d2');
    currentY += 10;

    // Add generation date
    const currentDate = new Date().toLocaleDateString();
    addText(`Generated on: ${currentDate}`, 10, false, '#666666');
    currentY += 15;

    // Add Radar Chart as image
    await this.addChartAsImage(pdf, html2canvas, '.chart-and-heatmap', '', {
      fullPage: false,
      captureScale: 2,
    });

    // Add Heatmap as image
    // await this.addChartAsImage(
    //   pdf,
    //   html2canvas,
    //   '.heatmap-container',
    //   'Cloud Readiness Heatmap'
    // );

    // Helper function to add a section header
    const addSectionHeader = (title: string) => {
      // Add some space before section
      currentY += sectionSpacing;

      // Check if we need a new page for the section header
      if (currentY + 15 > pageHeight - margin) {
        pdf.addPage();
        currentY = margin;
      }

      addText(title, 16, true, '#1976d2');
      currentY += 5; // Extra space after header
    };

    //Add summary title
    addText('Assessment Summary', 20, true, '#1976d2');
    currentY += 10;

    // // Add generation date
    // const currentDate = new Date().toLocaleDateString();
    // addText(`Generated on: ${currentDate}`, 10, false, '#666666');
    // currentY += 15;

    // Process each section
    const sectionKeys = Object.keys(this.answers.answers);

    for (const sectionKey of sectionKeys) {
      const sectionData = this.answers.answers[sectionKey];

      // Add section header
      addSectionHeader(
        `${sectionKey.charAt(0).toUpperCase() + sectionKey.slice(1)} Section`,
      );

      // Calculate average rating for this section
      const avgRating =
        sectionData.reduce((sum, item) => sum + item.rating, 0) /
        sectionData.length;
      const status =
        avgRating >= 4
          ? 'Good'
          : avgRating >= 3
            ? 'Needs Improvement'
            : 'Requires Attention';
      const statusColor =
        avgRating >= 4 ? '#4caf50' : avgRating >= 3 ? '#ff9800' : '#f44336';

      addText(`Average Rating: ${avgRating.toFixed(1)}/5`, 12, true);
      addText(`Status: ${status}`, 12, true, statusColor);
      currentY += 10;

      // Add each item in the section
      sectionData.forEach((item, index) => {
        // Add item title
        addText(`${index + 1}. ${item.title}`, 14, true);
        currentY += 3;

        // Add question
        addText(`Question: ${item.question}`, 11, false);
        currentY += 3;

        // Add response
        addText(`Response: ${item.response}`, 11, false);
        currentY += 3;

        // Add rating
        addText(`Rating: ${item.rating}/5`, 11, true);
        currentY += 5;

        // Add recommendations if available
        if (item.recommendations && item.recommendations.length > 0) {
          addText('Recommended Actions:', 12, true, '#1976d2');
          currentY += 3;

          // use for..of so we can update currentY from the helper return value
          for (const rec of item.recommendations) {
            // Process HTML links in recommendations — addTextWithLinks returns the new Y
            currentY = this.addTextWithLinks(
              pdf,
              `• ${rec}`,
              10,
              false,
              currentY,
            );
            currentY += 2; // small gap after each recommendation
          }
        }

        currentY += 8; // Space between items
      });

      currentY += 10; // Extra space between sections
    }

    // Add summary section at the end
    addSectionHeader('Assessment Summary');

    sectionKeys.forEach((sectionKey) => {
      const sectionData = this.answers.answers[sectionKey];
      const avgRating =
        sectionData.reduce((sum, item) => sum + item.rating, 0) /
        sectionData.length;
      const status =
        avgRating >= 4
          ? 'Good'
          : avgRating >= 3
            ? 'Needs Improvement'
            : 'Requires Attention';
      const statusColor =
        avgRating >= 4 ? '#4caf50' : avgRating >= 3 ? '#ff9800' : '#f44336';

      addText(
        `${
          sectionKey.charAt(0).toUpperCase() + sectionKey.slice(1)
        }: ${avgRating.toFixed(1)}/5 - ${status}`,
        11,
        false,
        statusColor,
      );
    });

    // Add footer
    currentY = pageHeight - 15;
    addText(
      'Cloud Readiness Assessment Report - Generated by NetSync',
      8,
      false,
      '#666666',
    );

    // Save the PDF
    pdf.save('cloud-readiness-assessment-report.pdf');

    // Show success message
    this.commonService.successMessage(
      'PDF report generated successfully with charts and selectable text!',
    );
  }

  private addTextWithLinks(
    pdf: any,
    text: string,
    fontSize: number,
    isBold: boolean,
    startY: number,
  ): number {
    // Inline layout renderer: renders plain words and <a> links on the same line,
    // wraps when needed and avoids inserting extra blank lines around links.
    const normalize = (s: string) =>
      (s || '')
        .replace(/\r?\n|\r/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

    const raw = text || '';
    const normalizedText = normalize(raw);
    if (!normalizedText) return startY;

    pdf.setFontSize(fontSize);
    pdf.setFont('helvetica', isBold ? 'bold' : 'normal');
    pdf.setTextColor('#000000');

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 20;
    const contentRight = pageWidth - margin;
    // Use a tighter line height based on fontSize.
    // previous formula produced very large gaps for common font sizes (e.g. 10 => 12).
    // New formula keeps spacing compact but readable: at least 5px, otherwise ~0.8 * fontSize.
    const lineHeight = Math.max(5, Math.round(fontSize * 0.8));
    let currentY = startY;
    let currentX = margin;

    // Parse into segments: plain text and links
    const linkRegex = /<a[^>]*href=['"]([^'"]*)['"][^>]*>([^<]*)<\/a>/gi;
    const segments: Array<{
      type: 'text' | 'link';
      text: string;
      url?: string;
    }> = [];

    let lastIndex = 0;
    let m: RegExpExecArray | null;
    linkRegex.lastIndex = 0;
    while ((m = linkRegex.exec(normalizedText)) !== null) {
      if (m.index > lastIndex) {
        const before = normalizedText.substring(lastIndex, m.index);
        const normBefore = normalize(before);
        if (normBefore) segments.push({ type: 'text', text: normBefore });
      }
      const linkText = (m[2] || '').trim();
      if (linkText) segments.push({ type: 'link', text: linkText, url: m[1] });
      lastIndex = m.index + m[0].length;
    }
    if (lastIndex < normalizedText.length) {
      const rest = normalize(normalizedText.substring(lastIndex));
      if (rest) segments.push({ type: 'text', text: rest });
    }

    // Helper to ensure vertical space
    const ensureSpaceFor = (neededLines = 1) => {
      if (currentY + lineHeight * neededLines > pageHeight - margin) {
        pdf.addPage();
        currentY = margin;
        currentX = margin;
      }
    };

    const spaceWidth = pdf.getTextWidth(' ');

    // Render segments inline, word-wrapping by measuring widths
    for (let si = 0; si < segments.length; si++) {
      const seg = segments[si];

      if (seg.type === 'text') {
        const words = seg.text.split(' ');
        for (let i = 0; i < words.length; i++) {
          const word = words[i];
          const withSpace = i < words.length - 1 ? word + ' ' : word;
          const w = pdf.getTextWidth(withSpace) as number;

          // wrap if not enough horizontal space
          if (currentX + w > contentRight) {
            currentY += lineHeight;
            currentX = margin;
            ensureSpaceFor(1);
          }
          ensureSpaceFor(1);
          pdf.setTextColor('#000000');
          pdf.text(withSpace, currentX, currentY);
          currentX += w;
        }
      } else {
        // link segment
        const linkText = seg.text;
        const url = seg.url || '';
        const linkWidth = pdf.getTextWidth(linkText) as number;

        // Add one-character space BEFORE link when not at line start
        const needLeadingSpace = currentX > margin;
        // If adding the leading space would overflow, wrap first
        if (
          needLeadingSpace &&
          currentX + spaceWidth + linkWidth > contentRight
        ) {
          currentY += lineHeight;
          currentX = margin;
          ensureSpaceFor(1);
        } else if (needLeadingSpace) {
          // advance X by one space width (do NOT include the space in the clickable link)
          currentX += spaceWidth;
        }

        // If link doesn't fit on current line after handling leading space, wrap
        if (currentX + linkWidth > contentRight) {
          currentY += lineHeight;
          currentX = margin;
          ensureSpaceFor(1);
        }
        ensureSpaceFor(1);

        // draw link inline (leading space is not part of clickable area)
        pdf.setTextColor('#1976d2');
        pdf.setFont('helvetica', isBold ? 'bold' : 'normal');
        pdf.textWithLink(linkText, currentX, currentY, { url });
        currentX += linkWidth + spaceWidth; // leave a space after link
        pdf.setTextColor('#000000');
      }
    }

    // Move to next line after finished segment block
    currentY += lineHeight;
    return currentY;
  }

  private async addChartAsImage(
    pdf: any,
    html2canvas: any,
    selector: string,
    title: string,
    options: { fullPage?: boolean; captureScale?: number } = {},
  ): Promise<void> {
    try {
      const chartElement = document.querySelector(selector) as HTMLElement;
      if (!chartElement) {
        console.warn(`Chart element not found: ${selector}`);
        return;
      }

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 20;
      const isFull = !!options.fullPage;

      // 1) Fast path: if ECharts instance available, use getDataURL (much faster than html2canvas)
      const echartsLib = (window as any).echarts;
      if (echartsLib) {
        try {
          const chartInstance = echartsLib.getInstanceByDom(chartElement);
          if (chartInstance && typeof chartInstance.getDataURL === 'function') {
            // choose pixelRatio moderately high to avoid blurring but not too large to slow down
            const pixelRatio = options.captureScale || 2;
            const dataUrl = chartInstance.getDataURL({
              type: 'png',
              pixelRatio,
              backgroundColor: '#ffffff',
              excludeComponents: ['toolbox', 'timeline', 'brush'],
            });

            // create image and await load to get natural dimensions
            const img = new Image();
            img.src = dataUrl;
            await new Promise<void>((resolve, reject) => {
              img.onload = () => resolve();
              img.onerror = () =>
                reject(
                  new Error('Failed to load chart image from ECharts dataURL'),
                );
            });

            const imgWidth = img.naturalWidth;
            const imgHeight = img.naturalHeight;

            // Fit image to page (full or remaining area)
            const contentWidth = pageWidth - 2 * margin;
            const contentHeight = isFull
              ? pageHeight - 2 * margin
              : pageHeight - margin - margin - 35;

            // Prefer filling height for prominent charts (radar), else fit preserving aspect
            let fitScale = Math.min(
              contentWidth / imgWidth,
              contentHeight / imgHeight,
            );
            if (isFull) {
              // try to use most of vertical space
              fitScale = contentHeight / imgHeight;
              if (imgWidth * fitScale > contentWidth) {
                fitScale = contentWidth / imgWidth;
              }
            }

            const drawW = imgWidth * fitScale;
            const drawH = imgHeight * fitScale;
            const xOffset = (pageWidth - drawW) / 2;
            const yOffset = isFull ? margin : 35;

            pdf.addImage(dataUrl, 'PNG', xOffset, yOffset, drawW, drawH);
            if (isFull) pdf.addPage();
            return;
          }
        } catch (e) {
          console.warn(
            'ECharts fast-export failed, falling back to html2canvas',
            e,
          );
          // fall through to html2canvas fallback
        }
      }

      // 2) Fallback: optimized html2canvas capture (reduced scale + JPEG + cropping to element)
      // minimize capture size and quality for speed, but keep acceptable clarity
      const deviceScale = (window && (window as any).devicePixelRatio) || 1;
      const baseScale = Math.max(1, Math.round(deviceScale));
      const requestedScale =
        options.captureScale && options.captureScale > 0
          ? options.captureScale
          : 1.5;
      const captureScale = Math.min(3, baseScale * requestedScale); // cap to avoid huge canvases

      // measure element's visible size (use client size to avoid huge scrollHeight)
      const rect = chartElement.getBoundingClientRect();
      const captureWidth = Math.max(1, Math.round(rect.width));
      const captureHeight = Math.max(1, Math.round(rect.height));

      const canvas = await html2canvas(chartElement, {
        scale: captureScale,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
        width: captureWidth,
        height: captureHeight,
        scrollX: 0,
        scrollY: 0,
        windowWidth: captureWidth,
        windowHeight: captureHeight,
        foreignObjectRendering: false,
        removeContainer: true,
        imageTimeout: 2000,
      });

      // Use JPEG for faster encoding and smaller size (choose quality 0.7)
      const imgData = canvas.toDataURL('image/jpeg', 0.7);
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;

      // Fit to page
      const contentWidth = pageWidth - 2 * margin;
      const currentY = isFull ? margin : 35;
      const contentHeight = isFull
        ? pageHeight - 2 * margin
        : pageHeight - currentY - margin;

      const fitScale = Math.min(
        contentWidth / imgWidth,
        contentHeight / imgHeight,
      );
      const scaledWidth = imgWidth * fitScale;
      const scaledHeight = imgHeight * fitScale;
      const xOffset = (pageWidth - scaledWidth) / 2;
      const yOffset = currentY;

      // Draw and advance page if using full
      if (yOffset + scaledHeight <= pageHeight - margin) {
        pdf.addImage(
          imgData,
          'JPEG',
          xOffset,
          yOffset,
          scaledWidth,
          scaledHeight,
        );
      } else {
        pdf.addPage();
        pdf.addImage(
          imgData,
          'JPEG',
          xOffset,
          margin,
          scaledWidth,
          scaledHeight,
        );
      }
      // if (isFull) pdf.addPage();
      // Add new page for next content
      pdf.addPage();
    } catch (error) {
      console.error(`Error capturing chart ${selector}:`, error);
      pdf.addPage();
    }
  }
}
